import { Popover } from "bootstrap";
import AutoComplete from "@tarekraafat/autocomplete.js";

const pageContent = document.getElementById('page-content');
const tabLinks = document.querySelectorAll('#curated-choices a');
const resourceGrid = document.getElementById('resource-grid');
const reviewGrid = document.getElementById('review-selected-pane');
const allResourcesTab = document.getElementById('all');
const myResourcesTab = document.getElementById('my-resources');
const selections = window.selections;
const CancelToken = axios.CancelToken;
let formSubmitted = false;

tabLinks.forEach(tab => {
    tab.addEventListener('click', event => {
        event.preventDefault();
        const element = event.currentTarget;
        const href = element.getAttribute('href');

        history.pushState(null, null, href);

        updateTabs(tab, href);
    });
});

window.onpopstate = function (event) {
    const pathSegments = location.pathname.split('/');
    let tabName = pathSegments[pathSegments.length - 1];
    if (tabName === 'resource-gallery') {
        pathSegments.push('all');
        tabName = 'all';
    }
    const tab = document.getElementById(tabName);
    const href = pathSegments.join('/');

    updateTabs(tab, href);
};

initializeComponents();

function updateTabs(tab, href) {
    let destination = `${href}/html`;

    selectActiveTab(tab);

    updateGridAndSettings(() => axios.get(destination));
}

function hideFlashMessage() {
    const flashMessage = document.querySelector('#page-content > .flash-message');
    if (flashMessage) flashMessage.parentNode.removeChild(flashMessage);
}

function selectActiveTab(tab) {
    tabLinks.forEach(tab => tab.classList.remove('active'));
    tab.classList.add('active');
}

function getActiveTab() {
    return document.querySelectorAll('#curated-choices a.active')[0];
}

function startLoadingAnimation() {
    pageContent.classList.add('loading');
}

function stopLoadingAnimation() {
    pageContent.classList.remove('loading');
}

function initializeComponents() {
    initializePopovers();

    if (window.ltiGallery) {
        initializeAddLtiResource();
    } else {
        initializeViewDetailSelect();
        initializeToggles();
        initializeResourceCountPopover();
        initializeLogInLink();
        initializeStandards();
    }

    if (allResourcesTab.classList.contains('active')) {
        initializeFilters();
        initializeSearchInsteadForLink();
    }

    if (
        allResourcesTab.classList.contains('active') ||
        (myResourcesTab && myResourcesTab.classList.contains('active'))
    ) {
        initializeSearch();
    }
}

function initializeAddLtiResource()
{
    const addButtons = document.querySelectorAll('.add-button');
    addButtons.forEach(addButton => {
        addButton.addEventListener('click', event => {
            event.preventDefault();
            const element = event.currentTarget;
            const resource_id = element.parentElement.dataset.id;
            const request_timestamp = document.getElementById('request_timestamp').value;
            const id_token = document.getElementById('id_token').value;

            const apiRequest = () => axios.post('/v3/lti/resource-gallery/selection', {resource_id, request_timestamp, id_token});
            const animations = {startLoadingAnimation, stopLoadingAnimation};
            const onSuccess = response => {
                resourceGrid.innerHTML = response.data;

                document.getElementById('deep-link-response').submit();
            }
            const onError = () => window.location.href = '/v3/lti/timeout';

            submitApiRequest({apiRequest, onSuccess, onError, animations});
        });
    });
}

function initializeMyResourcesSearch()
{
    const searchForm = document.getElementById('my-resources-search');

    searchForm.addEventListener('submit', event => {
        event.preventDefault();
        applySettingsForMyResourcesTab();
    });
}

function initializeToggles()
{
    const toggles = [...document.querySelectorAll('.resource .select-toggle')];
    selections.initialize(toggles, {handleReviewSelections, handleClearSelections});
}

function initializePopovers() {
    const popoverToggles = $('a.filter-info');

    const popoverElements = document.querySelectorAll(
        '.filter-option [data-bs-toggle="popover"], .resource-item-count[data-bs-toggle="popover"]'
    );
    popoverElements.forEach((element) => new Popover(element));

    closePopoverWhenAnotherPopoverOpens(popoverToggles);
    closePopoverWhenClickingX(popoverToggles);
    handlePopoverClickEvents(popoverToggles);
    handleDropdownPopoverScrollEvents(popoverToggles);

    function closePopoverWhenAnotherPopoverOpens(toggles) {
        toggles.on('show.bs.popover', event => {
            const clickedToggle = event.target;
            toggles.not(clickedToggle).popover('hide');
        });
    }

    function closePopoverWhenClickingX(toggles) {
        toggles.on('shown.bs.popover', event => {
            document.querySelector('.close-popover').addEventListener('click', () => {
                const clickedToggle = event.target;
                $(clickedToggle).popover('hide');
            });
        });
    }

    function handlePopoverClickEvents(toggles) {
        document.body.addEventListener('click', (event) => {
            const popover = document.querySelector('.popover');

            if (popover === null) {
                return;
            }

            if (clickWasInPopover(popover, event.target)) {
                event.stopPropagation();
                return;
            }

            if (popoverLinkClicked(event.target)) {
                event.stopPropagation();
                return;
            }

            toggles.popover('hide');
        });
    }

    function handleDropdownPopoverScrollEvents(toggles) {
        const groupsFilterContainer = document.querySelectorAll('.filter-type-groups');
        const mobileFiltersAccordion = document.querySelector('#mobile-filters-accordion');

        if (groupsFilterContainer) {
            groupsFilterContainer.forEach((element) => {
                element.addEventListener('scroll', () => {
                    if (document.querySelector('.popover') === null) {
                        return;
                    }

                    toggles.popover('hide');
                });
            });
        }

        if (mobileFiltersAccordion) {
            mobileFiltersAccordion.addEventListener('scroll', () => {
                if (document.querySelector('.popover') === null) {
                    return;
                }

                toggles.popover('hide');
            });
        }
    }

    function clickWasInPopover(popover, clickedElement) {
        if (popover.contains(clickedElement)) {
            return true;
        }

        return false;
    }

    function popoverLinkClicked(clickedElement) {
        if (
            clickedElement.classList.contains('filter-info')||
            clickedElement.classList.contains('filter-info-icon')
        ) {
            return true;
        }

        return false;
    }
}

function initializeResourceCountPopover() {
    document.querySelectorAll('.resource-item-count').forEach(count => {
        count.addEventListener('click', function(event) {
            event.stopPropagation();
        });
    });
}

function initializeLogInLink() {
    const link = resourceGrid.querySelector('#register-log-in-text .login-link');

    if (link) {
        link.addEventListener('click', event => {
            event.preventDefault();
            $('.login-modal-trigger').click();
        });
    }
}

function initializeSearchInsteadForLink() {
    const link = resourceGrid.querySelector('.search-instead-for-link');

    if (link) {
        link.addEventListener('click', event => {
            event.preventDefault();

            const searchTextInput = document.querySelector('#search-form input[type="search"]');
            searchTextInput.value = link.innerHTML;

            const disableSpellCheck = document.querySelector('#search-form input[name="disable_spellcheck"]');
            disableSpellCheck.value = 1;

            applySettingsForAllResourcesTab();
        });
    }
}

function applySettingsForActiveTab() {
    const tab = getActiveTab();

    if (tab.id === 'all') {
        applySettingsForAllResourcesTab();
    } else if (tab.id === 'my-resources') {
        applySettingsForMyResourcesTab();
    } else {
        applySettingsForOtherTabs(tab);
    }
}

function initializeStandards() {
    window.standards.initialize();
}

function initializeViewDetailSelect() {
    const select = document.querySelector('#resource-grid .view-detail-select');

    select.addEventListener('change', applySettingsForActiveTab);
}

function applySettingsForAllResourcesTab()
{
    const viewOption = selectedViewOption();
    const filters = selectedFilterOptions();
    const sort = selectedSortOption();
    const searchText = chosenSearchText();
    const disableSpellCheck = spellCheckDisabled();
    let destination = `/v3/resource-gallery/all/html?view_settings=${viewOption}`;

    if (window.ltiGallery) {
        destination ='/v3/lti/resource-gallery/all/html';
    }

    updateGridAndSettings(() => axios.post(destination, {filters, sort, searchText, disableSpellCheck}));
}

function applySettingsForMyResourcesTab()
{
    const viewOption = selectedViewOption();
    const sort = selectedSortOption();
    const searchText = chosenSearchText();
    let destination = `/v3/resource-gallery/my-resources/html?view_settings=${viewOption}`;

    updateGridAndSettings(() => axios.post(destination, {sort, searchText}));
}

function applySettingsForOtherTabs(tab)
{
    const destination =
        `/v3/resource-gallery/${tab.id}/html?view_settings=${selectedViewOption()}`;

    updateGridAndSettings(() => axios.get(destination));
}

function selectedViewOption()
{
    const select = document.querySelector('#resource-grid .view-detail-select');
    return select ? select.value : 'brief';
}

function selectedFilterOptions()
{
    const filterMenus = [...document.querySelectorAll('.filters .dropdown')];
    return filterMenus.map(menu => ({
        type: menu.dataset.filterType,
        selectedOptions: Array.from(menu.querySelectorAll('input:checked')).map(input => input.value),
    }));
}

function selectedSortOption()
{
    const sortSelect = document.querySelector('#resource-grid .sort-select');
    return sortSelect ? sortSelect.value : 'alphabetical';
}

function chosenSearchText()
{
    const selectedSearchInput = document.getElementById('selected-search');
    return selectedSearchInput.value || null;
}

function setSearchText(text)
{
    const selectedSearchInput = document.getElementById('selected-search');
    selectedSearchInput.value = text;

    if (allResourcesTab.classList.contains('active')) {
        const relevanceOption = document.querySelector('.sort-select option[value=relevance]');
        relevanceOption.classList.remove('d-none');

        document.querySelector('.sort-select').value = 'relevance';
    }
}

function clearSearchText()
{
    const searchInput = document.getElementById('search-input');
    const selectedSearchInput = document.getElementById('selected-search');
    searchInput.value = '';
    selectedSearchInput.value = '';

    if (allResourcesTab.classList.contains('active')) {
        const relevanceOption = document.querySelector('.sort-select option[value=relevance]');
        relevanceOption.classList.add('d-none');

        document.querySelector('.sort-select').value = 'alphabetical';
    }
}

function spellCheckDisabled()
{
    const overrideSpellCheck = document.querySelector('#search-form input[name="disable_spellcheck"]');
    return overrideSpellCheck.value || null;
}

function updateGridAndSettings(apiRequest)
{
    hideFlashMessage();

    const onSuccess = response => {
        resourceGrid.innerHTML = response.data;
        initializeComponents();
    };

    const onError = ({openErrorModal}) => {
        openErrorModal();
        resourceGrid.innerHTML = '';
    };

    const animations = {startLoadingAnimation, stopLoadingAnimation};

    submitApiRequest({apiRequest, onSuccess, onError, onAuthError, animations});
}

function onAuthError()
{
    window.location.href = '/resource-gallery';
}

function handleReviewSelections(isReviewingResources, event)
{
    if (isReviewingResources) {
        applySettingsForActiveTab();
        selections.hideReview();
        window.scrollTo(0, 0);
    } else {
        applySettingsForReview(selectedViewOption());
    }

    function applySettingsForReview(initialSelectedViewOption)
    {
        const viewOption = initialSelectedViewOption || selectedReviewViewOption();
        const filters = selectedResources();
        const sort = selectedReviewSortOption();

        const destination = `/v3/resource-gallery/review/html?view_settings=${viewOption}`;

        updateReviewGrid(() => axios.post(destination, {filters, sort, showFilters: false}))
    }

    function selectedReviewViewOption()
    {
        const select = document.querySelector('#review-selected-pane .view-detail-select');
        if (select)
            return select.value;
    }

    function selectedResources()
    {
        return [{
            type: 'selected_resource',
            selectedOptions: selections.getSelections(),
        }];
    }

    function selectedReviewSortOption()
    {
        const sortSelect = document.querySelector('#review-selected-pane .sort-select');
        if (sortSelect)
            return sortSelect.value;
    }

    function updateReviewGrid(apiRequest)
    {
        selections.showReview();
        hideFlashMessage();

        const onSuccess = response => {
            reviewGrid.innerHTML = response.data;
            initializeComponents();
            initializeReviewComponents();
        };

        const onError = ({openErrorModal}) => {
            openErrorModal();
            reviewGrid.innerHTML = '';
        };

        const animations = {startLoadingAnimation, stopLoadingAnimation};

        submitApiRequest({apiRequest, onSuccess, onError, onAuthError, animations});
    }

    function initializeReviewComponents()
    {
        initializeReviewViewDetailSelect();
        initializeReviewSortSelect();
    }

    function initializeReviewViewDetailSelect() {
        const select = document.querySelector('#review-selected-pane .view-detail-select');

        select.addEventListener('change', () => {
            applySettingsForReview();
        });
    }

    function initializeReviewSortSelect() {
        const sortSelect = document.querySelector('#review-selected-pane .sort-select');
        sortSelect.addEventListener('change', () => applySettingsForReview());
    }
}

function handleClearSelections(isReviewingResources) {
    if (isReviewingResources) {
        applySettingsForActiveTab();
        window.scrollTo(0, 0);
    }
}

function initializeSearch() {
    formSubmitted = false;
    const searchForm = document.getElementById('search-form');
    const clearSearchButton = document.getElementById('clear-search');

    if (getActiveTab().id === 'all') {
        initializeSearchSuggestions();
    }

    searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
        formSubmitted = true;
        setSearchText(event.currentTarget.searchInput.value);
        applySettingsForActiveTab();
    });

    clearSearchButton.addEventListener('click', function () {
        clearSearchText();
        applySettingsForActiveTab();
    });
}

function initializeSearchSuggestions() {
    let cancel;
    const suggestions = new AutoComplete({
        selector: '#search-input',
        data: {
            src: async (searchText) => {
                if (formSubmitted) return [];

                try {
                    cancel && cancel.cancel();

                    cancel = CancelToken.source();
                    const filters = selectedFilterOptions();

                    const source = await axios.post(
                        '/v3/resource-gallery/suggestions',
                        {filters, searchText},
                        {cancelToken: cancel.token}
                    );
                    return source.data;
                } catch(error) {
                    return [];
                }
            }
        },
        searchEngine: (query, record) => {
            const search = new RegExp(`(${query})`, "i");
            return record.replace(search, '<mark>$1</mark>');
        },
        debounce: 500,
        threshold: 3,
        submit: true,
        resultsList: {
            maxResults: 10,
        },
        resultItem: {
            cache: true,
            highlight: true,
        },
        diacritics: true,
    });

    suggestions.input.addEventListener('selection', function (event) {
        const text = event.detail?.selection?.value ?? '';
        suggestions.input.value = text;
        setSearchText(text);
        applySettingsForActiveTab();
    });
}

function initializeFilters() {
    const openButton = document.querySelectorAll('#filters-and-settings .mobile-filters button')[0];
    const mobileMenu = document.getElementById('mobile-filters-menu');
    const closeButton = mobileMenu.querySelector('.mobile-close-button');
    const clearButton = mobileMenu.querySelector('.clear-filters-button');
    const applyButton = mobileMenu.querySelector('.apply-filters-button');
    const mobileFilterMenus = [...mobileMenu.querySelectorAll('.mobile-filter')];

    openButton.addEventListener('click', openMobileFiltersMenu);
    closeButton.addEventListener('click', closeMobileFiltersMenu);
    clearButton.addEventListener('click', clearFilters);
    applyButton.addEventListener('click', applyMobileFilters);

    const filterActions = document.getElementById('filter-actions');
    const applyFilter = document.getElementById('apply-filter');
    const cancelFilter = document.getElementById('cancel-filter');
    const clearFiltersAction = document.getElementById('clear-filters');
    const filterMenus = [...document.querySelectorAll('.filters .dropdown')];
    const sortSelect = document.querySelector('#resource-grid .sort-select');

    sortSelect.addEventListener('change', () => applySettingsForAllResourcesTab());

    let originalSelection = [];

    $('.filters .dropdown').on('show.bs.dropdown', function () {
        const filterType = this.dataset.filterType;
        const selectedFilters = selectedFilterOptions();

        if (originalSelection.length === 0) {
            originalSelection = findCurrentFiltersStatus();
        }

        updateFilterAvailability(filterType, selectedFilters);

        showActiveActions();
        hideClearFiltersAction();
    });

    $('.filters .dropdown').on('hide.bs.dropdown', function () {
        $('a.filter-info').popover('hide');
    });

    $('#mobile-filters-accordion .collapse').on('show.bs.collapse', function () {
        const filterType = $(this).closest('.mobile-filter').data('filter-type');
        const selectedFilters = selectedFilterOptions();

        updateFilterAvailability(filterType, selectedFilters);
    });

    openButton.addEventListener('click', () => {
        if (originalSelection.length === 0) {
            originalSelection = findCurrentFiltersStatus();
        }
    });

    applyFilter.addEventListener('click', () => applySettingsForAllResourcesTab());
    cancelFilter.addEventListener('click', resetFilters);
    cancelFilter.addEventListener('click', closeMobileFiltersMenu);
    closeButton.addEventListener('click', resetFilters);

    if (clearFiltersAction)
    {
        clearFiltersAction.addEventListener('click', clearFilters);
    }

    initializeSelectedFilteredCount(filterMenus);
    initializeSelectedFilteredCount(mobileFilterMenus);

    function findCurrentFiltersStatus()
    {
        const filterSelectionState = [...document.querySelectorAll('input[type="checkbox"]')];
        return filterSelectionState.map(el => ({id: el.id, checked: el.checked}));
    }

    function updateFilterAvailability(filterType, filters)
    {
        hideFlashMessage();

        const searchText = chosenSearchText();
        const destination = `/v3/resource-gallery/filters/${filterType}`;

        const apiRequest = () => axios.post(destination, {filters, searchText});

        const onSuccess = response => {
            const availableFilters = response.data;
            disableUnavailableFilters(filterType, availableFilters);
        };

        const animations = {
            startLoadingAnimation: () => startFilterLoadingAnimation(filterType),
            stopLoadingAnimation: () => stopFilterLoadingAnimation(filterType),
        };

        submitApiRequest({apiRequest, onSuccess, onAuthError, animations});

        function disableUnavailableFilters(filterType, availableFilters)
        {
            const options =
                document.querySelectorAll(`.filter-type-${filterType} .filter-option`);

            options.forEach(option => {
                const checkbox = option.querySelector('input');
                if (
                    !availableFilters.includes(checkbox.value) &&
                    !checkbox.checked
                ) {
                    option.classList.add('disabled');
                    checkbox.setAttribute('disabled', '')
                } else {
                    option.classList.remove('disabled');
                    checkbox.removeAttribute('disabled');
                }
            });
        }
    }

    function startFilterLoadingAnimation(filterType) {
        const menus = document.querySelectorAll(`.filter-type-${filterType}`);
        menus.forEach(menu => menu.classList.add('loading'));
    }

    function stopFilterLoadingAnimation(filterType) {
        const menus = document.querySelectorAll(`.filter-type-${filterType}`);
        menus.forEach(menu => menu.classList.remove('loading'));
    }

    function resetFilters()
    {
        originalSelection.forEach(option => {
            const checkbox = document.getElementById(option.id);
            checkbox.checked = option.checked;
        });

        filterMenus.forEach(menu => adjustFilterCount(menu));

        hideActiveActions();
        showClearFiltersAction();
    }

    function adjustFilterCount(menu) {
        const filterType = menu.dataset.filterType;
        const menus = document.querySelectorAll(`div[data-filter-type=${filterType}]`);
        menus.forEach(menu => {
            const badge = menu.querySelector('.badge');
            const selectedCount = menu.querySelectorAll('input:checked').length;
            badge.innerHTML = selectedCount;
            if (selectedCount >= 1) {
                badge.classList.remove('d-none');
            } else {
                badge.classList.add('d-none');
            }
        });
    }

    function initializeSelectedFilteredCount(filterMenus) {
        filterMenus.forEach(menu => {
            menu.addEventListener('click', function (event) {
                if (event.target.tagName === 'INPUT') {
                    handleFilterOptionClick(this, event.target);
                }
            });
        });
    }

    function handleFilterOptionClick(menu, checkbox)
    {
        synchronizeFilters(checkbox);
        adjustFilterCount(menu);
        showActiveActions();
        hideClearFiltersAction();
    }

    function showActiveActions()
    {
        filterActions.classList.add('d-inline');
        filterActions.classList.remove('d-none');
        applyButton.classList.add('show');
    }

    function hideActiveActions()
    {
        filterActions.classList.remove('d-inline');
        filterActions.classList.add('d-none');
        applyButton.classList.remove('show');
    }

    function showClearFiltersAction()
    {
        if (clearFiltersAction) {
            clearFiltersAction.classList.add('d-inline');
            clearFiltersAction.classList.remove('d-none');
        }
    }

    function hideClearFiltersAction()
    {
        if (clearFiltersAction) {
            clearFiltersAction.classList.add('d-none');
            clearFiltersAction.classList.remove('d-inline');
        }
    }

    function synchronizeFilters(checkbox)
    {
        const filterClassName = [...checkbox.classList]
            .find(className => className.startsWith('filter-'));

        document.querySelectorAll(`.${filterClassName}`)
            .forEach(otherCheckbox => otherCheckbox.checked = checkbox.checked);
    }

    function openMobileFiltersMenu() {
        window.modal.open(mobileMenu);
    }

    function closeMobileFiltersMenu() {
        window.modal.close(mobileMenu);
    }

    function clearFilters() {
        closeMobileFiltersMenu();
        const filterCheckboxes = [...document.querySelectorAll('input[type="checkbox"]')];
        filterCheckboxes.forEach(input => input.checked = false);
        applySettingsForAllResourcesTab();
    }

    function applyMobileFilters() {
        applySettingsForAllResourcesTab();
        closeMobileFiltersMenu();
    }
}
